import { httpClient as http } from '../services'

const internals = {}

internals.uploadProfileImage = (name, file, options) => {
	let data = new FormData()
	data.append('name', name)
	data.append('file', file)
	return http.post('/file/upload/profile-image', data, options)
}

internals.uploadImage = (name, file, options) => {
	let data = new FormData()
	data.append('name', name)
	data.append('file', file)
	return http.post('/file/upload/image', data, options)
}

internals.fileUpload = (file, options) => {
	let data = new FormData();
	if(Array.isArray(file)){
		for(let i=0; i<file.length; i++){
			data.append('file', file[i]);
		}
	}else{
		data.append('file', file);
	}
	return http.post('/fileUpload', data, options)
}

export default internals



// WEBPACK FOOTER //
// ./src/services/file.service.js